'use client';

import SignIn from '@/components/auth/SignInForm';
import SignUpForm from '@/components/auth/SignUpForm';
import { useAuthModal } from '@/context/AuthModalContext';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, useMediaQuery } from '@mui/material';
const SignInModal = () => {
  const {
    isOpen,
    view,
    openModal,
    closeModal
  } = useAuthModal();
  const isSmall = useMediaQuery('(min-width:400px)');
  return <>
      <Stack direction="row" spacing={1} sx={{
      display: {
        xs: 'flex'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="SignInModal.tsx">
        <Button variant="outlined" color="inherit" sx={{
        fontWeight: 600,
        borderRadius: '6px'
      }} size={isSmall ? 'small' : 'medium'} onClick={() => {
        openModal('signIn');
      }} data-sentry-element="Button" data-sentry-source-file="SignInModal.tsx">
          Sign in
        </Button>
        <Button variant="contained" color="primary" sx={{
        fontWeight: 600,
        borderRadius: '6px',
        display: {
          xs: 'none',
          sm: 'inline-flex'
        }
      }} size={isSmall ? 'small' : 'medium'} onClick={() => {
        openModal('signUp');
      }} data-sentry-element="Button" data-sentry-source-file="SignInModal.tsx">
          Sign up
        </Button>
      </Stack>

      <Dialog open={isOpen} maxWidth="sm" fullWidth onClose={() => {
      closeModal();
    }} data-sentry-element="Dialog" data-sentry-source-file="SignInModal.tsx">
        <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="SignInModal.tsx">{view === 'signIn' ? 'Sign In' : 'Sign Up'}</DialogTitle>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="SignInModal.tsx">
          {view === 'signIn' ? <SignIn setModalView={openModal} isInModal redirectTo="/exams" /> : <SignUpForm isInModal />}
        </DialogContent>
        <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="SignInModal.tsx">
          <Button onClick={() => {
          closeModal();
        }} data-sentry-element="Button" data-sentry-source-file="SignInModal.tsx">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>;
};
export default SignInModal;